import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import LanguageSwitcher from "./LanguageSwitcher";

export default function Navbar() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const scrollTo = (id) => {
    if (location.pathname !== "/") {
      // Ako nismo na glavnoj stranici, navigiraj na glavnu i zatim scrollaj
      window.location.href = `/#${id}`;
      return;
    }
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
      setOpen(false);
    }
  };

  return (
    <header className="navbar">
      <div className="container nav-inner">
        <div className="nav-left">
          <div className="logo">{t("brand")}</div>
        </div>
        <nav className={`nav-links ${open ? "open" : ""}`}>
          <button onClick={() => scrollTo("hero")}>{t("nav.home")}</button>
          <button onClick={() => scrollTo("tours")}>{t("nav.tours")}</button>
          <button onClick={() => scrollTo("destinations")}>
            {t("nav.destinations")}
          </button>
          <button onClick={() => scrollTo("reviews")}>
            {t("nav.reviews")}
          </button>
          <Link to="/blog" onClick={() => setOpen(false)}>
            {t("nav.blog")}
          </Link>
          <button onClick={() => scrollTo("contact")}>
            {t("nav.contact")}
          </button>
          <Link to="/admin/login" onClick={() => setOpen(false)} className="admin-link">
            🔐 Admin
          </Link>
        </nav>
        <div className="nav-right">
          <LanguageSwitcher />
          <button
            className="nav-toggle"
            onClick={() => setOpen((prev) => !prev)}
            aria-label="Toggle menu"
          >
            <span className={`hamburger ${open ? "open" : ""}`}>
              <span></span>
              <span></span>
              <span></span>
            </span>
          </button>
        </div>
      </div>
    </header>
  );
}
